import { LeftOutlined } from "@ant-design/icons";
import { Typography } from "antd";
import React from "react";
import "./index.scss";

const { Text } = Typography;

interface SettingsSidebarHeaderProps {
  title: string;
  handleBackClick: any;
  endElement?: any;
}

const SettingsSidebarHeader: React.FC<SettingsSidebarHeaderProps> = ({
  title,
  handleBackClick,
  endElement,
}) => {
  return (
    <div className="settings-sidebar-header">
      <LeftOutlined className="arrow-btn" onClick={handleBackClick} />
      <Text className="heading">{title}</Text>
      {endElement ? endElement : <div className="dummy-div"></div>}
    </div>
  );
};

export default SettingsSidebarHeader;
